export * from './static-path-offer-fixed-line';
export * from './static-path-offer-mobile-line';
export * from './static-path-offer-dati-line';
export * from './static-path-device-smartphone';
export * from './static-path-device-tablet';